import React from 'react';
export default function LayoutSection(props) {
    return React.createElement("div", { "data-layout-section": true }, props.children);
}
//# sourceMappingURL=layoutSection.js.map